var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"m60s-assessment",attrs:{"dir":_vm.$i18n.locale === 'ar-AR' ? 'rtl' : 'ltr'}},[(_vm.kind === 'infrared')?[_c('m60-s-infrared',{attrs:{"report-data":_vm.data}})]:[_c('m60-s-vital-signs',{attrs:{"report-data":_vm.data}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }